import { Injectable } from "@angular/core";
import { CookieService } from "./cookie.service";
import { AccessRights, UsersService, InterfacePermissions } from './users.service';

class ComponentItem
{
  component: any;
  type: string;

  constructor(component: any, type: string)
  {
    this.component = component;
    this.type = type ? type : "";
  }
}

@Injectable()
export class JSProxyService
{
  vars: Map<string, any>;
  components: Map<string, ComponentItem>;
  constructor(private cookieService: CookieService, private usersService: UsersService)
  {
    this.vars = new Map<string, any>();
    this.components = new Map<string, any>();
  }

  private convertVar(value: string)
  {
    if (value == "false")
      return false;
    if (value == "true")
      return true;
    return value;
  }

  public getVar(name: string, defval: any): any
  {
    if (this.vars.has(name))
      return this.vars.get(name);

    let cookie = localStorage.getItem(name);
    //let cookie = this.cookieService.get(name);
    if (typeof (cookie) != "undefined" && cookie != "" && cookie != null)
    {
      this.vars.set(name, this.convertVar(cookie));
      return this.vars.get(name);
    }
    return defval;
  }
  public setVar(name: string, val: any, useCookies: boolean): void
  {
    this.vars.set(name, val);
    if (useCookies)
      localStorage.setItem(name, val);
      //this.cookieService.set(name, val, 14);
  }
  public canAccessComponent(rights: AccessRights): boolean {
    return this.usersService.IsPermitted(rights);
  }
  /////////////////////////////////////////////////////////////
  public registerComponent(name: string, component: any, type: string): void
  {
    this.components.set(name, new ComponentItem(component, type));
  }
  public unRegisterComponent(name: string): void
  {
    this.components.delete(name);
  }
  public getComponent(name: string): any
  {
    return this.components.has(name) ? this.components.get(name).component : null;
  }
}
